import { apiClient } from '@/shared/lib/apiClient';
import type { ApiSuccessResponse } from '@super-admin/shared-types';

import type {
  PortalSubscriptionUpgradePreviewResponse,
  PortalUpgradePreviewRequest,
} from '../types/portalUpgradePreview';

export async function fetchPortalUpgradePreview(
  input: PortalUpgradePreviewRequest,
): Promise<PortalSubscriptionUpgradePreviewResponse> {
  const res = await apiClient.get<ApiSuccessResponse<PortalSubscriptionUpgradePreviewResponse>>(
    '/api/v1/customer/subscription/upgrade-preview',
    {
      params: {
        targetPlanCode: input.targetPlanCode,
        billingCycle: input.billingCycle,
      },
    },
  );
  return res.data;
}
